import { Config3d } from '@ff-scene-plugins/gift-shared/GiftVariantOptions';

export const loadGltf = async (config3d: Config3d) => {
    const assetResponse = await fetch(config3d.modelAssetUrl, { mode: 'cors' });
    return JSON.parse(await assetResponse.text());
};